import { createAsyncThunk } from '@reduxjs/toolkit';
import { setProjectConfigurationService } from 'store/project-configurations/services/setProjectConfigurationService.service';

export const setProjectConfiguration = createAsyncThunk(
  'projectConfigurations/setProjectConfiguration',
  async (params, { getState }) => {

    const editedProjectConfiguration = await setProjectConfigurationService(params);

    return editedProjectConfiguration;
  }
);